import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, IconButton, Typography } from '@mui/material';
import { useAuth } from 'utils/contexts/auth-context';
import { NAV_BG, NAV_COLOR } from 'utils/styles/colors';
import {
  removeCountryCode,
  formatPhoneNumber,
} from 'utils/services/format-phone-number';

interface INavbar {
  showUserMenu?: boolean;
}

const NavBar: React.FC<INavbar> = () => {
  const { signOut, sorensonUser } = useAuth();

  const formatNumber = () => {
    const phoneNumber = removeCountryCode(sorensonUser.name);
    return formatPhoneNumber(phoneNumber.toString());
  };

  return (
    <>
      {sorensonUser.name !== '' && (
        <AppBar color='secondary'>
          <Container
            id='navbar-container'
            maxWidth={false}
            disableGutters
            sx={{
              position: 'relative',
              height: '100px',
            }}
          >
            <Toolbar
              id='toolbar-container'
              disableGutters
              sx={{
                background: NAV_BG,
                justifyContent: 'space-between',
                height: '100%',
                padding: '0 42px',
              }}
            >
              <Box>
                <Typography
                  id='navbar-user'
                  sx={{
                    color: NAV_COLOR,
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                >
                  {Number.parseInt(sorensonUser.name)
                    ? formatNumber()
                    : sorensonUser.name}
                </Typography>
                <Typography
                  id='navbar-user-email'
                  sx={{
                    color: NAV_COLOR,
                    fontSize: '14px',
                    fontWeight: '400',
                  }}
                >
                  {sorensonUser.email}
                </Typography>
              </Box>
              <Box>
                <IconButton
                  id='navbar-logout-button'
                  sx={{
                    width: '112px',
                    height: '36px',
                    borderRadius: '6px',
                    border: '1px solid',
                    borderColor: NAV_COLOR,
                  }}
                  aria-label='save'
                  onClick={signOut}
                >
                  <LogoutIcon
                    id='navbar-logout-icon'
                    style={{
                      color: NAV_COLOR,
                      fontSize: 20,
                      marginRight: '8px',
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: '14px',
                      color: NAV_COLOR,
                      fontWeight: 500,
                    }}
                  >
                    Sign Out
                  </Typography>
                </IconButton>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )}
    </>
  );
};

export default NavBar;
